import ApiService from "@/common/api.service"

export const ProgramEventService = {
    create(params) {
        return ApiService.post("/events/add", params);
    },
    update(slug, params) {
        return ApiService.update("/events", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("/events/delete", slug, params)
    },
    async getProgramEvents() {
        const res = await ApiService.get("/events");
        return res.data;
    },
    async getEventByCPDActivity(cpdActivityId) {
        const res = await ApiService.get("/events/all/byCpdActivity/" + cpdActivityId);
        return res.data;
    }

}